export default __webpack_public_path__ + "static/media/backgrounHome.ccaa1256.png";